// framework/client/components/PaymentGatewayComponent.js
// (Replace the entire file with this new version)

import { ComponentBase } from "../core/ComponentBase.js";
import { RazorpayClientHelper } from "../helpers/payment/RazorpayClientHelper.js";
// Import other helpers like PayPalClientHelper here in the future

export class PaymentGatewayComponent extends ComponentBase {
    constructor(config) {
        super(config);
        this.helpers = new Map();
        this._boundHandleInitiatePayment = this.handleInitiatePayment.bind(this);
    }

    async initialize() {
        // Register all available client-side helpers
        this.helpers.set('razorpay', new RazorpayClientHelper({ appClient: this.appClient }));
        // this.helpers.set('paypal', new PayPalClientHelper({ appClient: this.appClient }));

        // Listen for the global event fired by BillingView or any other component
        this.appClient.events.local.on('initiatePayment', this._boundHandleInitiatePayment);
        await super.initialize();
    }

    // --- NEW: Implement the render method ---
    // This component is non-visual, so it just creates a container for itself.
    render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.id = `payment-gateway-component-${this.config.instanceId}`;
            // This container will be hidden as it has no content.
        }
        return this.container;
    }

    async handleInitiatePayment(paymentPayload) {
        try {
            // 1. Ask the server for the available gateways and which one to use.
            const gatewayInfo = await this.appClient.rpcClient.call('PaymentGatewayRpc.getAvailableGateways');
            const gatewayName = gatewayInfo.selectedGateway;
            const gatewayClientConfig = gatewayInfo.config;

            if (!gatewayName || !this.helpers.has(gatewayName)) {
                throw new Error(`The selected payment gateway '${gatewayName}' is not supported by the client.`);
            }

            // 2. Create the payment order on the server.
            const orderData = await this.appClient.rpcClient.call('BillingRpc.createRechargeOrder', {
                amount: paymentPayload.amount,
                currency: paymentPayload.currency,
                gatewayName: gatewayName
            });

            // 3. Get the correct helper and initiate the client-side payment flow.
            const helper = this.helpers.get(gatewayName);
            await helper.initiatePayment({ ...orderData, ...gatewayClientConfig });

        } catch (error) {
            this.log.error("Payment initiation failed:", error);
            this.appClient.notifier.error(`Payment Error: ${error.message}`);
        }
    }

    // --- NEW: Implement the destroy method to clean up the event listener ---
    destroy() {
        this.appClient.events.local.off('initiatePayment', this._boundHandleInitiatePayment);
        this.helpers.forEach(helper => {
            if (typeof helper.destroy === 'function') {
                helper.destroy();
            }
        });
        super.destroy();
    }
}